import { T, Var } from 'gt-react';
import config from 'src/config';
import { cn } from 'src/lib/utils';

/** "Gently © <year> <support email>", shown at the foot of the user menu. */
export function CopyrightNotice({ className }: { className?: string }) {
  const year = new Date().getFullYear();
  return (
    <span
      className={cn('text-xs text-muted-foreground/50 font-light', className)}
    >
      <T context="copyright footer notice with support email">
        Gently © <Var>{year}</Var> <Var>{config.supportEmail}</Var>
      </T>
    </span>
  );
}
